import React from 'react';
import Dialog from '@material-ui/core/Dialog';

import Slide from '@material-ui/core/Slide';

import { TransitionProps } from '@material-ui/core/transitions'
import MuiDialogTitle from '@material-ui/core/DialogTitle';

import MuiDialogContent from '@material-ui/core/DialogContent';

import Typography from '@material-ui/core/Typography';

import { createStyles, IconButton, Theme, withStyles, WithStyles } from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import { red } from '@material-ui/core/colors';
//@ts-ignore
//const Transition = React.forwardRef(function Transition(props, ref) {return <Slide direction="up" ref={ref} {...props} />;});
//@ts-ignore
const Transition = React.forwardRef<HTMLElement, TransitionProps>((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const styles = (theme: Theme) =>
    createStyles({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: red[500],
        },
    });

export interface DialogTitleProps extends WithStyles<typeof styles> {
    id: string;
    children: React.ReactNode;
    onClose: () => void;
    IsFullScreen?: boolean;
}
const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, IsFullScreen = false, ...other } = props;
    return (

        <MuiDialogTitle disableTypography  {...other} style={{ paddingTop: 0, paddingBottom: 0 }}>

            <Typography variant="h5">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" size="small" className={classes.closeButton} style={{ marginRight: IsFullScreen ? 20 : 0 }} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}

        </MuiDialogTitle >

    );
});

const DialogContent = withStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);


export interface ModalBoxProps {
    Open?: boolean;
    isOpen?: boolean;
    Title?: string;
    title?: string;
    children: React.ReactNode;
    CloseButtonText?: string;
    CloseButtonClick?: () => void;
    handleClose?: () => void;
    IsFullScreen?: boolean;
}

export default function ModalBox(props: ModalBoxProps) {
    const Open = props.Open ?? props.isOpen ?? false;
    const Title = props.Title ?? props.title;
    const CloseButtonClick = props.CloseButtonClick ?? props.handleClose ?? (() => {});
    const children = props.children;
    const CloseButtonText = props.CloseButtonText || "Close";
    const IsFullScreen = props.IsFullScreen || false;

    const handleCloseButtonClick = () => {
        CloseButtonClick && CloseButtonClick();
    };


    return (
        <div>

            <Dialog
                maxWidth="lg"
                fullWidth
                disableBackdropClick
                fullScreen={IsFullScreen}
                TransitionComponent={Transition}
                onClose={handleCloseButtonClick}
                aria-labelledby="customized-dialog-title"
                open={Open}>
                <DialogTitle id="customized-dialog-title" onClose={handleCloseButtonClick} IsFullScreen={IsFullScreen}>
                    {Title}
                </DialogTitle>
                <DialogContent>

                    {children}

                </DialogContent>
            </Dialog>
        </div>
        // <Backdrop className={classes.backdrop} open={Open}>
        //     <div>
        //         <div
        //             style={{
        //                 display: "flex",
        //                 flexDirection: "row",
        //                 alignItems: "flex-end",
        //                 alignContent: "flex-end",
        //                 justifyContent: "flex-end"

        //             }}>
        //             <IconButton edge="end" onClick={CloseButtonClick}>
        //                 <CloseIcon color="error" />
        //             </IconButton>

        //         </div>
        //         {children}
        //     </div>
        // </Backdrop>
    );
}
